import React from 'react';

const InProgressIcon = ({ color = '#454F5B', scale = 1 }: { color?: string; scale?: number }): JSX.Element => (
  <svg width={24 * scale} height={24 * scale} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width={24 * scale} height={24 * scale} fill="white" fillOpacity="0.01" />
    <path
      d="M11 2.21001C11 1.57001 10.42 1.10001 9.8 1.22001C8.40001 1.51001 7.09001 2.06001 5.94001 2.83001C5.42001 3.18001 5.35001 3.93001 5.79001 4.37001C6.12001 4.70001 6.63001 4.77001 7.02001 4.51001C7.98001 3.87001 9.06 3.41001 10.23 3.17001C10.69 3.09001 11 2.67001 11 2.21001Z"
      fill={color}
    />
    <path
      d="M18.06 2.83001C16.91 2.06001 15.6 1.51001 14.2 1.22001C13.58 1.10001 13 1.57001 13 2.21001C13 2.67001 13.31 3.09001 13.76 3.18001C14.93 3.41001 16.02 3.88001 16.97 4.52001C17.36 4.78001 17.87 4.71001 18.2 4.38001C18.66 3.93001 18.59 3.18001 18.06 2.83001Z"
      fill={color}
    />
    <path
      d="M2.84001 5.94C3.18001 5.42 3.93001 5.34 4.38001 5.79C4.70001 6.12 4.77001 6.64 4.52001 7.02C3.88001 7.98 3.41 9.07 3.18001 10.24C3.09001 10.69 2.67001 11 2.21001 11C1.58001 11 1.10001 10.42 1.23001 9.8C1.51001 8.39 2.07001 7.09 2.84001 5.94Z"
      fill={color}
    />
    <path
      d="M21.79 11C22.42 11 22.9 10.42 22.77 9.8C22.48 8.4 21.93 7.1 21.16 5.94C20.81 5.42 20.06 5.34 19.62 5.79C19.29 6.12 19.22 6.63 19.48 7.02C20.12 7.98 20.58 9.07 20.82 10.24C20.91 10.69 21.33 11 21.79 11Z"
      fill={color}
    />
    <path
      d="M10.44 13.57L8 12.46C7.61 12.28 7.61 11.72 8 11.54L10.44 10.44L11.55 8.00002C11.73 7.61002 12.28 7.61002 12.46 8.00002L13.56 10.44L16 11.55C16.39 11.73 16.39 12.28 16 12.46L13.56 13.56L12.45 16C12.27 16.39 11.72 16.39 11.54 16L10.44 13.57Z"
      fill={color}
    />
    <path
      d="M12 21C8.89 21 6.15 19.41 4.54 17H6C6.55 17 7 16.55 7 16C7 15.45 6.55 15 6 15H2C1.45 15 1 15.45 1 16V20C1 20.55 1.45 21 2 21C2.55 21 3 20.55 3 20V18.3C4.99 21.14 8.27 23 12 23C16.45 23 20.27 20.36 22 16.57C22.26 16 21.92 15.32 21.31 15.18C20.86 15.08 20.38 15.29 20.19 15.72C18.77 18.83 15.64 21 12 21Z"
      fill={color}
    />
  </svg>
);

export default InProgressIcon;
